import Tool from '../tool';
import * as constants from '../../constants';
import toggleSolutionButton from '../../shared-ui/toggle-solution-button';

const unitLength = 27;
const gridLength = 12 * unitLength;

let currentQuestion;

const sprite = new PIXI.Sprite();

const titleText = new PIXI.Text('', { font: '18px Open Sans, Arial', fill: 0xFFFFFF });
const grid = new PIXI.Sprite();
const gridNumbers = new PIXI.Container(); 
const axisLabels = new PIXI.Container();
const toggleSolutionBtn = toggleSolutionButton();

sprite.addChild(titleText);
sprite.addChild(grid);
sprite.addChild(gridNumbers);
sprite.addChild(axisLabels);
sprite.addChild(toggleSolutionBtn);

titleText.y = 10;
grid.y = gridNumbers.y = axisLabels.y = 80;
toggleSolutionBtn.y = grid.y + gridLength + 10;

titleText.anchor.set(0.5, 0);
titleText.x = constants.screenCentreX;

grid.x = gridNumbers.x = axisLabels.x = ( constants.screenWidth - gridLength ) / 2;
toggleSolutionBtn.x = ( constants.screenWidth - toggleSolutionBtn.width ) / 2;

const selectionG = new PIXI.Graphics();
const borders = new PIXI.Graphics();
grid.addChild(selectionG);
grid.addChild(borders);

grid.hitArea = new PIXI.Rectangle(0, 0, gridLength, gridLength);
grid.cursor = 'pointer';

// draw grid
borders.lineStyle(3, constants.grey);
for ( let i = 0; i <= 12; i++ ) {
  borders.moveTo(0, i * unitLength).lineTo(gridLength, i * unitLength); // horizontal line
  borders.moveTo(i * unitLength, 0).lineTo(i * unitLength, gridLength); // vertical line
}

// draw grid numbers
const gridNumberStyle = { font: '12px Open Sans, Arial', fill: 0xFFFFFF };
for ( let i = 0; i < 12; i++ ) {
  for ( let j = 0; j < 12; j++ ) {
    const s = ( i + 1 ) * ( j + 1 );
    const t = new PIXI.Text(s, gridNumberStyle);
    gridNumbers.addChild(t);
    t.anchor.set(0.5);
    t.x = i * unitLength + unitLength / 2;
    t.y = j * unitLength + unitLength / 2;
  }
}

// draw axis labels
const axisLabelStyle = { font: '15px Open Sans, Arial', fill: 0xFFFFFF };
const t = new PIXI.Text(constants.multiplicationSign, axisLabelStyle);
t.anchor.set(0.5);
t.position.set(-0.5 * unitLength, -0.5 * unitLength);
axisLabels.addChild(t);
for ( let i = 0; i < 12; i++ ) {
  const tx = new PIXI.Text(( i + 1 ), axisLabelStyle);
  const ty = new PIXI.Text(( i + 1 ), axisLabelStyle);
  axisLabels.addChild(tx);
  axisLabels.addChild(ty);
  tx.anchor.set(0.5);
  ty.anchor.set(0.5);
  tx.position.set(( i + 0.5 ) * unitLength, -0.5 * unitLength);
  ty.position.set(-0.5 * unitLength, ( i + 0.5 ) * unitLength);
}

grid.on('pointerdown', e => {
  if ( currentQuestion.isCompleted ) {
    return;
  }
  currentQuestion.answer = gridPointFromEvent(e);
  drawSelection(currentQuestion.answer);
});

function drawSelection( point, colour ) {
  selectionG.clear();

  if ( !point ) {
    return;
  }

  if ( typeof colour === 'undefined' ) {
    colour = constants.orange;
  }

  selectionG
  .beginFill(colour, 0.6)
  .drawRect(0, unitLength * ( point.y - 1 ), unitLength * 12, unitLength)
  .drawRect(unitLength * ( point.x - 1 ), 0, unitLength, unitLength * 12)
  .endFill()
  .beginFill(colour)
  .drawRect(unitLength * ( point.x - 1 ), unitLength * ( point.y - 1 ), unitLength, unitLength)
  .endFill();
}

function gridPointFromEvent( e ) {
  const coords = grid.toLocal(e.data.global);
  const x = 1 + Math.floor(coords.x / unitLength);
  const y = 1 + Math.floor(coords.y / unitLength);
  return new PIXI.Point(x, y);
}

export default class ChartTool extends Tool {
  static init() {
    this._sprite = sprite;
    this.toggleSolutionBtn = toggleSolutionBtn;
  }

  static loadQuestion( question ) {
    super.loadQuestion(question);
    grid.interactive = true;
    currentQuestion = question;
    drawSelection(null);
    titleText.text = question.title;
    axisLabels.visible = question.axisLabels;
    gridNumbers.visible = question.showNums !== 'none';
    
    if ( gridNumbers.visible ) {
      for ( let i = 0; i < 12; i++ ) {
        for ( let j = 0; j < 12; j++ ) {
          var t = gridNumbers.children[ i * 12 + j ];
          t.visible =
              question.showNums === 'all' ||
              ( i + 1 ) === question.multiplicand ||
              ( j + 1 ) === question.multiplier;
        }
      }
    }
  }

  static onQuestionComplete( question ) {
    super.onQuestionComplete(question);
    grid.interactive = false;
    this.showUserSolution(question);
  }

  static showCorrectSolution( question ) {
    drawSelection(question.correctSolution(), constants.green);
  }
  static showUserSolution( question ) {
    drawSelection(question.answer, question.result ? constants.green : constants.red);
  }
}
